import Tooltip from './Tooltip';

export default Tooltip;


//////////////////
// WEBPACK FOOTER
// ../rc-tooltip/es/index.js
// module id = 663
// module chunks = 25